import { render, staticRenderFns } from "./CardOverflowContainer.vue?vue&type=template&id=478ebc57"
import script from "./CardOverflowContainer.vue?vue&type=script&lang=js"
export * from "./CardOverflowContainer.vue?vue&type=script&lang=js"
import style0 from "./CardOverflowContainer.vue?vue&type=style&index=0&id=478ebc57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/skade-pwa/components/ui/atom/Icon.vue').default})
